<svelte:options accessors />

<script context="module">
  export function getStats(initialism) {
    const returnDict = {};
    for (let [index, section] of testContents.default.entries()) {
      const subRange = section.classes.filter(
        (rangeInfo) => rangeInfo.abbreviation === initialism.charAt(index)
      )[0];
      returnDict[section.heading] = (subRange.min + subRange.max) / 2;
    }
    //    console.log(returnDict);
    return returnDict;
  }
</script>

<script>
  export let abbr;

  import * as typologies from "../configs/typologies.json";

  //import {convertAbbreviated,fullstopize} from "../global";
  import * as conversions from "../configs/conversions.json";
  import * as testContents from "../configs/testItems.json";

  import StatsBars from "../ponents/StatsBars.svelte";

  import Initialism from "./Initialism.svelte";

  import * as broadClasses from "../configs/broadClasses.json";
  const broadClassesList = broadClasses.default;

  import { sum } from "../global";
  //import GenderSelect from "./GenderSelect.svelte";

  let block;

  let yOffset = 0;

  window.addEventListener(
    "scroll",
    () => {
      if (!block) return;
      const bounds = block.getBoundingClientRect();
      yOffset = (window.innerHeight - (bounds.top + bounds.bottom) / 2) / 3;
    },
    { passive: true }
  );

  $: parallaxShift = yOffset;

  //

  import SelectedGender from "../stores/Persistent";
  $: gender = $SelectedGender;
  $: archetype = typologies.default[abbr][gender];
</script>

<div style="--parallax-shift : {Math.round(parallaxShift)}px;">
  {#if $SelectedGender}
    <article
      bind:this={block}
      style="--color: {archetype.color}; --spotlight-color: {archetype.spotlightColor}; --background-texture: {archetype.backgroundTexture ??
        'linear-gradient(to right,transparent,transparent)'};"
      class="shadow-lg"
    >
      <div class="row">
        <div class="col-md-5">
          <img
            src="/pictures/archetypes/{archetype.gender}/{archetype.name}.png"
            alt={archetype.name}
            class="rounded"
          />
        </div>
        <div class="col-md-7">
          <h2 class="h1">
            {archetype.name} · <Initialism
              initials={abbr}
              dictWhatEveryLetterStandsFor={conversions}
            />
          </h2>
          <h2>
            {#each broadClassesList as broadClass}
              {@const sumScore = sum(Object.values(getStats(abbr)))}
              {#if broadClass.min <= sumScore && sumScore <= broadClass.max}
                {broadClass.label}
              {/if}
            {/each}
          </h2>
          <p class="lead">
            {archetype.description}
          </p>
          <StatsBars statsDict={getStats(abbr)} />
        </div>
      </div>
    </article>
  {/if}
</div>

<style>
  article > .row > *,
  article > .row > * > h2.h1 + h2 {
    margin-bottom: 2.5rem;
  }
  article {
    z-index: 1;
    position: relative;
    background-blend-mode: darken, color-dodge, color-dodge, multiply,
      soft-light;
    color: white;
    text-shadow:
      0 0 2.5rem var(--spotlight-color),
      0 0 1.25rem white,
      0 2px #0000007f,
      -1px 1px #0000007f,
      1px 1px #0000007f;
    /*padding: 5rem 0 2.5rem 0;*/
    background-image: linear-gradient(to right, darkgray, darkgray),
      radial-gradient(circle 25rem at top, var(--spotlight-color), transparent),
      radial-gradient(
        circle 25rem at bottom,
        var(--spotlight-color),
        transparent
      ),
      linear-gradient(to right, darkgray, darkgray), var(--background-texture);
    background-size:
      100% 100%,
      100% 100%,
      100% 100%,
      100% 100%,
      100vmax auto;
    background-position:
      center center,
      center center,
      center center,
      center center,
      center calc(50% + var(--parallax-shift, 0px));
    background-color: var(--color);
    /*transition: background-position .1s;*/
    will-change: background-position;
    /*
      border-width: 0 99999px 0 99999px;
      border-style: solid;
      border-color: var(--color);
      */
    margin: 0 -9999px 0 -9999px;
    padding: 5rem 9999px 2.5rem 9999px;
    text-align: center;
  }
  article img {
    object-fit: contain;
    object-position: center center;
    width: 100%;
    min-height: 100%;
    height: 25rem;
    overflow: hidden;
  }
  [class^="col-"] {
    position: relative;
  }
</style>
